var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlatformIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 3H11.5C12.3284 3 13 3.67157 13 4.5V11.5C13 12.3284 12.3284 13 11.5 13H4.5C3.67157 13 3 12.3284 3 11.5V4.5C3 3.67157 3.67157 3 4.5 3ZM1.5 4.5C1.5 2.84315 2.84315 1.5 4.5 1.5H11.5C13.1569 1.5 14.5 2.84315 14.5 4.5V11.5C14.5 13.1569 13.1569 14.5 11.5 14.5H4.5C2.84315 14.5 1.5 13.1569 1.5 11.5V4.5ZM9.99902 10.751C9.99902 11.1652 10.3348 11.501 10.749 11.501C11.1632 11.501 11.499 11.1652 11.499 10.751V8.74911C11.499 8.33489 11.1632 7.99911 10.749 7.99911C10.3348 7.99911 9.99902 8.33489 9.99902 8.74911V10.751ZM8.00098 11.501C7.58676 11.501 7.25098 11.1652 7.25098 10.751L7.25098 5.24911C7.25098 4.83489 7.58676 4.49911 8.00098 4.49911C8.41519 4.49911 8.75098 4.83489 8.75098 5.24911L8.75098 10.751C8.75098 11.1652 8.41519 11.501 8.00098 11.501ZM4.50293 10.751C4.50293 11.1652 4.83872 11.501 5.25293 11.501C5.66714 11.501 6.00293 11.1652 6.00293 10.751V7.24911C6.00293 6.83489 5.66714 6.49911 5.25293 6.49911C4.83872 6.49911 4.50293 6.83489 4.50293 7.24911L4.50293 10.751Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlatformIcon);
export default __webpack_public_path__ + "static/media/PlatformIcon.238c660841c8c072758153624db08345.svg";
export { ForwardRef as ReactComponent };